import {InputLabel, FormGroup, Paper, TextField, Typography, FormControl, Button, MenuItem, Select} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import { useState, useEffect } from "react";
//import { useDispatch, useSelector } from "react-redux";
//import {createHotel, getHotels} from "../actions/customer"
import { fetchEmployees, addEmployee } from "../api/customerapi";
import {formatDate2} from "./date.js"



const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(60),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    headertext: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    formgroup: {
        justifyContent: "center",   
    },
    textArea: {
        marginLeft: theme.spacing(12),
        marginRight: theme.spacing(14),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(15),
        height: theme.spacing(6),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
  }));

const Employeedataentry = () => {

    const classes = useStyles();
    
    //const dispatch=useDispatch();
    const [employeeData, setemployeeData] =useState({
        name: "",
        email:"",
        role:"",
        reporting_manager: "",
        designation:"",
        
    });
    
    const [eData, seteData]=useState([]);
   

    const getEmployees = async () => {
        try{
        const data = await fetchEmployees();
        //const custdatalistfromdb= data.data
        //seteData(data.data.filter(emp => emp.role=="Admin"))
        seteData(data.data.filter(emp => emp.role=="Admin" || emp.role=="TL" || emp.role=="Support" || emp.role=="Operations" || emp.role=="Operations-TL" || emp.role=="Marketing" || emp.role=="Manager" || emp.role=="Product"))
    }catch(err){
        console.log(err)
      }
    }

   

    useEffect(() => {
        getEmployees()
        
        
    }, [])

  

    //console.log(dest);

    const handleSubmit =async (e) => {
        try{
        e.preventDefault();
        // const sortedemployeedatalistfromdb=eData.sort((a,b) => b.employee_id - a.employee_id);
        // const highestemployeeid=sortedemployeedatalistfromdb[0].employee_id;
        // const newemployeeid = highestemployeeid + 1;
        // const finalemployeeData= {...employeeData, employee_id: newemployeeid};
        const addemployeeResponse= await addEmployee(employeeData);
        // dispatch(createCustomer(finalcustData));
        //console.log(addcustResponse.data.cust_id);
        if(addemployeeResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
            alert("New employee added with employee id "+addemployeeResponse.data.employee_id);
            window.location = ("/employeedataentry/"+addemployeeResponse.data.employee_id);
        }
        else{
            alert("Something went wrong. Contact support");
            window.location = ("/");
        }
        //dispatch(createHotel(finalhotelData));
    }catch(err){
        console.log(err)
      }
        
    }

    return ( 
        <Paper variant="outlined" className={classes.paper} elevation={10}>
            <Typography variant="h4" align="center" className={classes.headertext}> Add New Employee</Typography>
            <form onSubmit={handleSubmit}>
            
            <FormGroup row className={classes.formgroup}>
                <TextField variant="standard"  required label="Name"  value={employeeData.name} className={classes.textField} onChange={(e)=> setemployeeData({...employeeData, name: e.target.value})}/>
                <TextField variant="standard"  label="Email"  value={employeeData.email} className={classes.textField} onChange={(e)=> setemployeeData({...employeeData, email: e.target.value})}/>
                <TextField variant="standard"  label="Contact (number)"  value={employeeData.contact} className={classes.textField} onChange={(e)=> setemployeeData({...employeeData, contact: e.target.value})}/>
                 <TextField variant="standard"  label="Cloud (number)"  value={employeeData.cloud_number} className={classes.textField} onChange={(e)=> setemployeeData({...employeeData, cloud_number: e.target.value})}/>
                
            </FormGroup>


            <FormGroup row className={classes.formgroup}>
            <TextField variant="standard"  required label="Short Name"  value={employeeData.short_name} className={classes.textField} onChange={(e)=> setemployeeData({...employeeData, short_name: e.target.value})}/>
            <TextField variant="standard"  required label="Proxy Name"  value={employeeData.proxy_name} className={classes.textField} onChange={(e)=> setemployeeData({...employeeData, proxy_name: e.target.value})}/>
            
            <FormControl style={{minWidth: 450, marginTop: 16, marginRight: 20, marginLeft: 8}}>
            <InputLabel id="Designation">Designation</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="Designation" value={employeeData.designation} onChange={(e)=> setemployeeData({...employeeData, designation: e.target.value})}>
                <MenuItem value={"L1-Sales"}>L1-Sales</MenuItem>
                    <MenuItem value={"L2-Sales"}>L2-Sales</MenuItem>
                    <MenuItem value={"L3-Sales"}>L3-Sales</MenuItem>
                    <MenuItem value={"L4-Sales"}>L4-Sales</MenuItem>
                    <MenuItem value={"L1-Operations"}>L1-Operations</MenuItem>
                    <MenuItem value={"L2-Operations"}>L2-Operations</MenuItem>
                    <MenuItem value={"L3-Operations"}>L3-Operations</MenuItem>
                    <MenuItem value={"L4-Operations"}>L4-Operations</MenuItem>
                    <MenuItem value={"L1-Marketing"}>L1-Marketing</MenuItem>
                    <MenuItem value={"L2-Marketing"}>L2-Marketing</MenuItem>
                    <MenuItem value={"L3-Marketing"}>L3-Marketing</MenuItem>
                    <MenuItem value={"L4-Marketing"}>L4-Marketing</MenuItem>
                    <MenuItem value={"L1-Accounts"}>L1-Accounts</MenuItem>
                    <MenuItem value={"L2-Accounts"}>L2-Accounts</MenuItem>
                    <MenuItem value={"L3-Accounts"}>L3-Accounts</MenuItem>
                    <MenuItem value={"L4-Accounts"}>L4-Accounts</MenuItem>
                    <MenuItem value={"L1-Product"}>L1-Product</MenuItem>
                    <MenuItem value={"L2-Product"}>L2-Product</MenuItem>
                    <MenuItem value={"L3-Product"}>L3-Product</MenuItem>
                    <MenuItem value={"L4-Product"}>L4-Product</MenuItem>
                    <MenuItem value={"L1-HR & Admin"}>L1-HR & Admin</MenuItem>
                    <MenuItem value={"L2-HR & Admin"}>L2-HR & Admin</MenuItem>
                    <MenuItem value={"L3-HR & Admin"}>L3-HR & Admin</MenuItem>
                    <MenuItem value={"L4-HR & Admin"}>L4-HR & Admin</MenuItem>

                    <MenuItem value={"L5"}>L5</MenuItem>
                    <MenuItem value={"L6"}>L6</MenuItem>
                    <MenuItem value={"L7"}>L7</MenuItem>
                    
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 450, marginTop: 16, marginRight: 20, marginLeft: 8}}>
            <InputLabel id="Manager">Reporting Manager</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="Manager" value={employeeData.reporting_manager} onChange={(e)=> setemployeeData({...employeeData, reporting_manager: e.target.value})}>
                    
                    {eData.map(emp => {
                    return <MenuItem value={emp.short_name}>{emp.name}</MenuItem>})}
                    
                </Select>
                </FormControl>
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                <TextField variant="standard"  type="date" label="Date of birth"  InputLabelProps={{ shrink: true }} value={employeeData.dob} className={classes.textField} onChange={(e)=> setemployeeData({...employeeData, dob: e.target.value})}/>
                <TextField variant="standard"  type="date" label="Date of joining"  InputLabelProps={{ shrink: true }} value={employeeData.doj} className={classes.textField} onChange={(e)=> setemployeeData({...employeeData, doj: e.target.value})}/>
                <FormControl style={{minWidth: 450, marginTop: 16, marginRight: 20, marginLeft: 8}}>
            <InputLabel id="Role">Role</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="Role" value={employeeData.role} onChange={(e)=> setemployeeData({...employeeData, role: e.target.value})}>
                    <MenuItem value={"Admin"}>Admin</MenuItem>
                    <MenuItem value={"Sales"}>Sales</MenuItem>
                    <MenuItem value={"Support"}>Support</MenuItem>
                    <MenuItem value={"Operations"}>Operations</MenuItem>
                    <MenuItem value={"TL"}>TL</MenuItem>
                    <MenuItem value={"External"}>External</MenuItem>
                    <MenuItem value={"Marketing"}>Marketing</MenuItem>
                </Select>
                </FormControl>
            </FormGroup>
            
            <FormGroup row className={classes.formgroup}>
                <Button variant="contained" color="primary" type="submit" className={classes.button}>Save</Button>
                <Button href="/home" variant="contained" color="secondary" className={classes.button}>Cancel</Button>
            </FormGroup>
              
            </form>
        </Paper>
     );
}

export default Employeedataentry;